<template>
    <div id="app">
        <v-app id="inspire" style="background: #CFD8DC">
            <v-container>
                <v-layout>
                    <h4 class="subheading font-weight-medium">DASHBOARD</h4>
                    <v-spacer></v-spacer>
                    <h4 class="subheading font-weight-medium">{{user.displayName}}</h4>
                </v-layout>

                <v-container grid-list-md text-xs-center>
                    <v-layout row wrap>
                        <v-flex xs3>
                            <v-card class="mt-4 mx-auto" max-width="400" height="180">
                                <v-layout>
                                    <v-flex xs6>
                                    <v-sheet class="v-sheet--offset mx-3" color="success" elevation="12" width="70" height="70">
                                        <br>
                                        <v-icon size="30" color="white">store</v-icon>
                                    </v-sheet>
                                    </v-flex>
                                    
                                    <v-flex xs6>
                                        <h4 class="mt-3 display-1 font-weight-bold text-sm-center">{{todaySelfService.length}}</h4>
                                    </v-flex>
                                </v-layout>

                                <v-card-text class="pt-0 pb-0">
                                    <h4 class="title font-weight-light">Self-Service</h4>
                                    <p class="category d-inline-flex font-weight-light" v-if="selfServiceComparison > 0">
                                        <v-icon color="green" small> arrow_upward </v-icon>
                                        <span class="green--text">{{selfServiceComparison}}</span>&nbsp;
                                        increase in today's booking
                                    </p>
                                    <p class="category d-inline-flex font-weight-light" v-else>
                                        <v-icon color="red" small> arrow_downward </v-icon>
                                        <span class="red--text">{{selfServiceComparison}}</span>&nbsp;
                                        increase in today's booking
                                    </p>

                                    <v-divider class="my-2"></v-divider>
                                    <div v-if="previousSelfService.length < 1">
                                        <span class="grey--text">Insufficient data</span>
                                    </div>

                                    <div v-else>
                                        <p class="category d-inline-flex font-weight-light" v-if="selfServicePercentage > 0">
                                            <v-icon color="green mr-2" small> arrow_upward </v-icon>
                                            <span class="green--text">{{selfServicePercentage}}%</span>&nbsp;
                                            <span class="caption font-weight-light grey--text"> Since last month</span>
                                        </p>
                                        <p class="category d-inline-flex font-weight-light" v-else-if="selfServicePercentage < 0">
                                            <v-icon color="red mr-2" small> arrow_downward </v-icon>
                                            <span class="red--text">{{selfServicePercentage}}% &nbsp;</span>
                                            <span class="caption font-weight-light grey--text">Since last month</span>
                                        </p>
                                    </div>
                                    
                                </v-card-text>
                            </v-card>
                        </v-flex>

                        <v-flex xs3>
                            <v-card class="mt-4 mx-auto" max-width="400" height="180">
                                <v-layout>
                                    <v-flex xs6>
                                    <v-sheet class="v-sheet--offset mx-3" color="warning" elevation="12" width="70" height="70">
                                        <br>
                                        <v-icon size="30" color="white">directions_walk</v-icon>
                                    </v-sheet>
                                    </v-flex>
                                    
                                    <v-flex xs6>
                                        <h4 class="mt-3 display-1 font-weight-bold text-sm-center">{{todayWalkin.length}}</h4>
                                    </v-flex>
                                </v-layout>

                                <v-card-text class="pt-0 pb-0">
                                    <h4 class="title font-weight-light">Walk-in</h4>
                                    <p class="category d-inline-flex font-weight-light" v-if="walkinComparison>0">
                                        <v-icon color="green mr-2" small> arrow_upward </v-icon>
                                        <span class="green--text">{{walkinComparison}}</span>&nbsp;
                                        increase in today's service
                                    </p>
                                    <p class="category d-inline-flex font-weight-light" v-else>
                                        <v-icon color="red mr-2" small> arrow_downward </v-icon>
                                        <span class="red--text">{{walkinComparison}}</span>&nbsp;
                                        increase in today's service
                                    </p>
                                    <v-divider class="my-2"></v-divider>

                                    <div v-if="previousWalkin.length < 1">
                                        <span class="grey--text">Insufficient data</span>
                                    </div>

                                    <div v-else>
                                        <p class="category d-inline-flex font-weight-light" v-if="walkinPercentage > 0">
                                            <v-icon color="green mr-2" small> arrow_upward </v-icon>
                                            <span class="green--text">{{walkinPercentage}}% &nbsp;</span>
                                            <span class="caption font-weight-light grey--text">Since last month</span>
                                        </p>
                                        <p class="category d-inline-flex font-weight-light" v-else>
                                            <v-icon color="red mr-2" small> arrow_downward </v-icon>
                                            <span class="red--text">{{walkinPercentage}}% &nbsp;</span>
                                            <span class="caption font-weight-light grey--text">Since last month</span>
                                        </p>
                                    </div>
                                </v-card-text>
                            </v-card>
                        </v-flex>

                        <v-flex xs3>
                            <v-card class="mt-4 mx-auto" max-width="400" height="180">
                                <v-layout>
                                    <v-flex xs6>
                                    <v-sheet class="v-sheet--offset mx-3" color="error" elevation="12" width="70" height="70">
                                        <br>
                                        <v-icon size="30" color="white">error_outline</v-icon>
                                    </v-sheet>
                                    </v-flex>
                                    
                                    <v-flex xs6>
                                        <h4 class="mt-3 display-1 font-weight-bold text-sm-center">{{todayCancelled.length}}</h4>
                                    </v-flex>
                                </v-layout>

                                <v-card-text class="pt-0 pb-0">
                                    <h4 class="title font-weight-light">Cancelled & No Show</h4>
                                    <p class="category d-inline-flex font-weight-light" v-if="cancelComparison>0">
                                        <v-icon color="red" small> arrow_upward </v-icon>
                                        <span class="red--text">{{cancelComparison}}</span>&nbsp;
                                        increase in today's service
                                    </p>
                                    <p class="category d-inline-flex font-weight-light" v-else>
                                        <v-icon color="green" small> arrow_downward </v-icon>
                                        <span class="green--text">{{cancelComparison}}</span>&nbsp;
                                        increase in today's cancelled
                                    </p>
                                    <v-divider class="my-2"></v-divider>

                                    <div v-if="previousCancelled.length < 1">
                                        <span class="grey--text">Insufficient data</span>
                                    </div>

                                    <div v-else>
                                        <p class="category d-inline-flex font-weight-light" v-if="cancelPercentage > 0">
                                            <v-icon color="red mr-2" small> arrow_upward </v-icon>
                                            <span class="red--text">{{cancelPercentage}}% &nbsp;</span>
                                            <span class="caption font-weight-light grey--text" >Since last month</span>
                                        </p>
                                        <p class="category d-inline-flex font-weight-light" v-else>
                                            <v-icon color="green mr-2" small> arrow_downward </v-icon>
                                            <span class="green--text">{{cancelPercentage}}% &nbsp;</span>
                                            <span class="caption font-weight-light grey--text"> Since last month</span>
                                        </p>
                                    </div>
                                </v-card-text>
                            </v-card>
                        </v-flex>

                        <v-flex xs3>
                            <v-card class="mt-4 mx-auto" max-width="400" height="180">
                                <v-layout>
                                    <v-flex xs6>
                                    <v-sheet class="v-sheet--offset mx-3" color="info" elevation="12" width="70" height="70">
                                        <br>
                                        <v-icon size="30" color="white">people</v-icon>
                                    </v-sheet>
                                    </v-flex>
                                    
                                    <v-flex xs6>
                                        <h4 class="mt-3 display-1 font-weight-bold text-sm-center">{{todayForApproval.length}}</h4>
                                    </v-flex>
                                </v-layout>

                                <v-card-text class="pt-0 pb-0">
                                    <h4 class="title font-weight-light">For Approval</h4>
                                    <p class="category d-inline-flex font-weight-light" v-if="forApprovalComparison>0">
                                        <v-icon color="green" small> arrow_upward </v-icon>
                                        <span class="green--text">{{forApprovalComparison}}</span>&nbsp;
                                        increase in today's request
                                    </p>
                                    <p class="category d-inline-flex font-weight-light" v-else>
                                        <v-icon color="red" small> arrow_downward </v-icon>
                                        <span class="red--text">{{forApprovalComparison}}</span>&nbsp;
                                        increase in today's request
                                    </p>
                                    <v-divider class="my-2"></v-divider>

                                    <div v-if="previousSession.length < 1">
                                        <span class="grey--text">Insufficient data</span>
                                    </div>
                                    
                                    <div v-else> 
                                        <p class="category d-inline-flex font-weight-light" v-if="sessionPercentage > 0">
                                            <v-icon color="green mr-2" small> arrow_upward </v-icon>
                                            <span class="green--text">{{forApprovalPercentage}}% &nbsp;</span>
                                                <span class="caption font-weight-light grey--text"> Since last month</span>
                                        </p>
                                        <p class="category d-inline-flex font-weight-light" v-else>
                                            <v-icon color="red mr-2" small> arrow_downward </v-icon>
                                            <span class="red--text">{{forApprovalPercentage}}% &nbsp;
                                            </span>
                                            <span class="caption font-weight-light grey--text">Since last month</span>
                                        </p>
                                    </div>
                                </v-card-text>
                            </v-card>  
                        </v-flex>

                        <!-- <v-flex xs3>
                            <v-card class="mt-4 mx-auto" max-width="400" height="180">
                                <v-layout>
                                    <v-flex xs6>
                                    <v-sheet class="v-sheet--offset mx-3" color="info" elevation="12" width="70" height="70">
                                        <br>
                                        <v-icon size="30" color="white">people</v-icon>
                                    </v-sheet>
                                    </v-flex>
                                    
                                    <v-flex xs6>
                                        <h4 class="mt-3 display-1 font-weight-bold text-sm-center">{{todaySession.length}}</h4>
                                    </v-flex>
                                </v-layout>

                                <v-card-text class="pt-0 pb-0">
                                    <h4 class="title font-weight-light">Sessions</h4>
                                    <p class="category d-inline-flex font-weight-light" v-if="sessionComparison>0">
                                        <v-icon color="green" small> arrow_upward </v-icon>
                                        <span class="green--text">{{sessionComparison}}</span>&nbsp;
                                        increase in today's session
                                    </p>
                                    <p class="category d-inline-flex font-weight-light" v-else>
                                        <v-icon color="red" small> arrow_downward </v-icon>
                                        <span class="red--text">{{sessionComparison}}</span>&nbsp;
                                        increase in today's session
                                    </p>
                                    <v-divider class="my-2"></v-divider>

                                    <div v-if="previousSession.length < 1">
                                        <span class="grey--text">Insufficient data</span>
                                    </div>
                                    
                                    <div v-else> 
                                        <p class="category d-inline-flex font-weight-light" v-if="sessionPercentage > 0">
                                            <v-icon color="green mr-2" small> arrow_upward </v-icon>
                                            <span class="green--text">{{sessionPercentage}}% &nbsp;</span>
                                                <span class="caption font-weight-light grey--text"> Since last month</span>
                                        </p>
                                        <p class="category d-inline-flex font-weight-light" v-else>
                                            <v-icon color="red mr-2" small> arrow_downward </v-icon>
                                            <span class="red--text">{{sessionPercentage}}% &nbsp;
                                            </span>
                                                <span class="caption font-weight-light grey--text">Since last month</span>
                                        </p>
                                    </div>
                                </v-card-text>
                            </v-card>  
                        </v-flex> -->

                    </v-layout>
                </v-container>
            </v-container>

            <v-container grid-list-md text-xs-center>
                <v-layout>
                    <v-flex xs6 class="ml-4">
                        <v-card class="mx-auto" max-width="480">
                            <v-sheet class="v-sheet--offset mx-auto" color="cyan" elevation="12" max-width="calc(100% - 32px)">
                                <div class="chart-wrapper">
                                    <chart :options="chartOptionsLine"></chart>
                                </div>
                            </v-sheet>
                        
                            <v-card-text class="pt-0 pb-0">
                                <h4 class="title font-weight-light">Total Transactions</h4>
                                <p class="category d-inline-flex font-weight-light" v-if="showComparison > 0">
                                    <v-icon color="green" small> arrow_upward </v-icon>
                                    <span class="green--text">{{showComparison}}</span>&nbsp;
                                    increase in today's transaction
                                </p>
                                <p class="category d-inline-flex font-weight-light" v-else>
                                    <v-icon color="red" small> arrow_downward </v-icon>
                                    <span class="red--text">{{showComparison}}</span>&nbsp;
                                    increase in today's transaction
                                </p>
                                <br>
                                <p class="category d-inline-flex font-weight-light">
                                    <span class="green--text display-1 font-weight-bold text-sm-center">{{showTransactions.length}}</span>&nbsp;
                                    show transactions 
                                </p>
                                <v-divider class="my-2"></v-divider>

                                <div v-if="previousShow.length < 1">
                                    <span class="grey--text">Insufficient data</span>
                                </div>

                                <div v-else>
                                    <p class="category d-inline-flex font-weight-light" v-if="showPercentage > 0">
                                        <v-icon color="green mr-2" small> arrow_upward </v-icon>
                                        <span class="green--text">{{showPercentage}}% </span>
                                        <span class="caption font-weight-light grey--text">Since last month</span>
                                    </p>

                                    <p class="category d-inline-flex font-weight-light" v-else>
                                        <v-icon color="red mr-2" small> arrow_downward </v-icon>
                                        <span class="red--text">{{showPercentage}}% &nbsp;</span>
                                        <span class="caption font-weight-light grey--text">Since last month</span>
                                    </p>
                                </div>

                            </v-card-text>
                        </v-card>
                    </v-flex>

                    <!-- <v-flex xs6 class="mr-4">
                        <v-card class="mx-auto" max-width="480">
                            <v-sheet class="v-sheet--offset mx-auto" color="teal" elevation="12" max-width="calc(100% - 32px)">
                                <div class="chart-wrapper">
                                    <chart :options="laborChartOptionsBar"></chart>
                                </div>
                            </v-sheet>
                            
                        
                            <v-card-text class="pt-0 pb-0">
                                <h4 class="title font-weight-light">Labor Sales</h4>
                                <p class="category d-inline-flex font-weight-light" v-if="salesComparison > 0">
                                    <v-icon color="green" small> arrow_upward </v-icon>
                                    <span class="green--text">{{salesComparison}}</span>&nbsp;
                                    increase in today's sales
                                </p>
                                <p class="category d-inline-flex font-weight-light" v-else>
                                    <v-icon color="red" small> arrow_downward </v-icon>
                                    <span class="red--text">{{salesComparison}}</span>&nbsp;
                                    increase in today's sales
                                </p>
                                <br>
                                <p class="category d-inline-flex font-weight-light">
                                    <span class="green--text display-1 font-weight-bold text-sm-center">{{totalLaborSales}}</span>&nbsp;
                                    total sales 
                                </p>
                                <v-divider class="my-2"></v-divider>

                                <div v-if="previousSales.length < 1">
                                    <span class="grey--text">Insufficient data</span>
                                </div>

                                <div v-else>
                                    <p class="category d-inline-flex font-weight-light" v-if="salesPercentage > 0">
                                        <v-icon color="green mr-2" small> arrow_upward </v-icon>
                                        <span class="green--text">{{salesPercentage}}% </span>&nbsp;
                                        <span class="caption font-weight-light grey--text">Since last month</span>
                                    </p>
                                    <p class="category d-inline-flex font-weight-light" v-else>
                                        <v-icon color="red mr-2" small> arrow_downward </v-icon>
                                        <span class="red--text">{{salesPercentage}}% </span>&nbsp;
                                        <span class="caption font-weight-light grey--text">Since last month</span>
                                    </p>
                                </div>

                            </v-card-text>
                        </v-card>
                    </v-flex> -->
                </v-layout>
            </v-container>

            <!-- <v-container grid-list-md text-xs-center>
                <v-layout class="ml-4">
                    <v-flex xs6>
                    <v-card class="mt-4 mx-auto">
                    <v-sheet dark class="v-sheet--offset mx-3" color="amber darken-4" elevation="12" width="94%" height="70">
                        <br>
                        <h4 class="title font-weight-light">Top Performing Branches</h4>
                        <span class="caption font-weight-light">Since last month</span>
                    </v-sheet>
                    <v-data-table :headers="headers" :items="topBranches" :items-per-page="5" class="elevation-1">
                        <template v-slot:items="props">
                            <td class="text-xs-left">{{ props.item.branch }}</td>
                            <td class="text-xs-center">{{ props.item.percentage }}%</td>
                        </template>
                    </v-data-table>
                    </v-card>
                    </v-flex>

                    <v-flex xs6 class="mr-5">
                    <v-card class="mt-4 mx-auto" max-width="500">
                        <v-sheet class="v-sheet--offset mx-auto" color="deep-purple" elevation="12" max-width="calc(100% - 32px)">
                            <div class="chart-wrapper">
                                <chart :options="branchChartOptionsBar"></chart>
                            </div>
                        </v-sheet>
                    
                        <v-card-text class="pt-0">
                            <h4 class="title font-weight-light pb-0">Branch Ratings</h4>
                            <v-divider class="my-2"></v-divider>
                            <span class="caption font-weight-light grey--text">Since last month</span>
                        </v-card-text>
                    </v-card>
                    </v-flex>
                </v-layout>
            </v-container> -->
        </v-app>                
    </div>
</template>

<script>
import firebase from "firebase";
import firebaseui from "firebaseui";
import "../../node_modules/firebaseui/dist/firebaseui.css";
import { config } from "../firebaseConfig";
import router from '../router';
import { db } from '../main.js'
import { mapGetters, mapActions } from "vuex";
import store from '../stores'
import moment from 'moment'
import _ from 'lodash';
import { sort } from 'semver';

export default {
    data() {
        return {
            laborChartOptionsBar: {
                tooltip : {
                    trigger: "axis",
                },
                xAxis: {
                    data: [],
                    axisTick: {
                        alignWithLabel: true
                    }
                },
                yAxis: {
                    type: 'value'
                },
                series: [{
                    type: 'bar',
                    data: [],
                    barWidth: '50%',
                    label: {
                        normal: {
                            position: 'top',
                            show: true
                        }
                    }, 
                }],
                color: ["#ffffff"],
            },
            chartOptionsLine: {
                xAxis: {
                    data: []
                },
                yAxis: {
                    type: "value",
                },
                series: [
                    {
                    type: "line",
                    data: [],
                    lineWidth: '50%',
                    label: {
                        normal: {
                            position: 'right',
                            show: true
                        }
                    }, 
                    }
                ],
                color: ["#ffffff"],
                tooltip: {
                    trigger: 'axis'
                },
            },
            branchChartOptionsBar: {
                yAxis: {
                    data: [], 
                    axisLabel: {
                        inside: false,
                        textStyle: {
                            color: '#fff'
                        },
                        rotate: 30,
                        
                    },
                    
                    // axisTick: {
                    //     show: false
                    // },
                    // axisLine: {
                    //     show: false
                    // },
                    z:10,
                },
                xAxis: {
                    type: 'value',
                    splitLine: {
                        show: false
                    },
                    axisLabel: {
                        textStyle: {
                            color: '#fff'
                        },
                        formatter: '{value}%',
                    },
                    
                },
                
                series: [{
                    
                    type: 'bar',
                    data: [],
                    barWidth: '25%',
                    label: {
                        normal: {
                            position: 'right',
                            show: true,
                        }
                    },      
                }],
                color: ["#ffffff"],
            },
            allTransactions: [],
            pendingTransactions: [],
            sessions: [],
            previousSession: [],
            sessionPercentage: 0,
            sessionComparison: 0,
            laborSales: [],
            previousSales: [],
            totalLaborSales: 0,
            salesPercentage: 0,
            salesComparison: 0,
            cancelledTransactions: [],
            previousCancelled: [],
            cancelPercentage: 0,
            cancelComparison: 0,
            forApprovalTransactions: [],
            previousForApproval: [],
            forApprovalPercentage: 0,
            forApprovalComparison: 0,
            walkin: [],
            previousWalkin: [],
            walkinPercentage: 0,
            walkinComparison: 0,
            selfService: [],
            previousSelfService: [],
            selfServicePercentage: 0,
            selfServiceComparison: 0,
            showTransactions: [],
            previousShow: [],
            showPercentage: 0,
            showComparison: 0,
            topBranches: [],
            percentages: [],
            percentage: 0,
            labels: [],
            value: [],
            transactionsLabel: [],
            transactionsValue: [],
            branchesLabel: [],
            branchesValue: [],
            gradient: ['#ffd200', '#1feaea', '#f72047'],
            headers: [
                { text: 'Branch', align: 'left', sortable: false, value: 'branch'},
                { text: 'Percentage', align: 'center', value: 'percentage',sortable: false  },
            ],
            allTotalSales: [],
            laborSalesValues: [],
            todaySelfService: [],
            todayWalkin: [],
            todayCancelled: [],
            todayForApproval: [],
            todaySession: [],
            totalSalesLastMonth: 0,
        }
    },


    methods: {
        async fetchTransactions() {
            let self = this

            await db.collection("ServiceBooking"+self.$stage)
            .onSnapshot(function(querySnapshot) {
                self.allTransactions = []
                querySnapshot.forEach(function(doc) {
                   self.allTransactions.push(doc.data())
                })
            })

            await db.collection("ServiceBooking"+self.$stage).where("status", "==", "Waiting")
            .onSnapshot(function(querySnapshot) {
                self.pendingTransactions = []
                querySnapshot.forEach(function(doc) {
                    self.pendingTransactions.push(doc.data());
                });
            });
        },

        async fetchShowTransactions() {
            let self = this
            
            await db.collection("ServiceBooking"+self.$stage).where("tag", "==", "Show")
            .onSnapshot(function(querySnapshot) {
                self.showTransactions= []
                self.previousShow= []
                self.selfService = []
                var serviceYesterday = []
                var todayService = []
                var process = 0
                self.showPercentage = 0
                self.showComparison = 0
                var prevMonthFirstDay = new moment().subtract(1, 'months').date(1).toISOString().substr(0, 10)
                var startOfMonth = moment().startOf('month').add(1, 'days').toISOString().substr(0, 10)
                var endOfMonth = moment().endOf('month').toISOString().substr(0, 10)
                var prevStartOfMonth = moment(prevMonthFirstDay).startOf('month').add(1, 'days').toISOString().substr(0, 10)
                var prevEndOfMonth = moment(prevMonthFirstDay).endOf('month').toISOString().substr(0, 10)
                var today = new moment().utcOffset('+0800').toISOString().substr(0, 10)
                var yesterday = new moment().utcOffset('+0800').subtract(1, 'days').toISOString().substr(0, 10)

                querySnapshot.forEach(function(doc) {
                    if(doc.data().appointmentDate >= startOfMonth && doc.data().appointmentDate <= endOfMonth ) {
                        self.showTransactions.push(doc.data())
                        process++
                        if (doc.data().appointmentDate == yesterday) {
                            serviceYesterday.push(doc.data())
                        } else if (doc.data().appointmentDate == today) {
                            todayService.push(doc.data())
                        }
                    } else if (doc.data().appointmentDate >= prevStartOfMonth && doc.data().appointmentDate <= prevEndOfMonth ) {
                        self.previousShow.push(doc.data())
                    }
                });
                self.showPercentage = (((self.showTransactions.length / self.previousShow.length)*100)-100).toFixed(2)
                self.showComparison = (todayService.length - serviceYesterday.length)

                if (process === self.showTransactions.length) {
                    self.allTotalSales.forEach(function(doc) {
                        var d=new Date(doc.appointmentDate)
                        var shortMonthName = new Intl.DateTimeFormat("en-US", { month: "short" }).format
                        var shortName = shortMonthName(d)
                        var m = d.getMonth()+1
                        var year = d.getFullYear()
                        doc.year = year
                        doc.monthGroup = m
                        doc.monthGroupName = shortName
                        doc.estimateCharge= doc.estimateCharge.replace("PHP","").trim()
                    })

                    setTimeout(() => {
                        var result = _.chain(self.allTotalSales)
                        .filter('year')
                        .groupBy(x => x.monthGroupName)
                        .map((value, key) => 
                            ({  month: key,
                                totalamount: value.length,
                                year: _.map(value, "year").map(_.spread(_.merge)),
                            })).value();
                            self.laborSalesValues = result
                        
                        self.laborSalesValues.forEach(function(doc) {
                            self.transactionsValue.push(doc.totalamount)
                            self.transactionsLabel.push(doc.month)
                            self.chartOptionsLine.xAxis.data.push(doc.month)
                            self.chartOptionsLine.series.forEach(function(res) {
                                res.data.push(doc.totalamount)
                            })
                        })

                    }, 1000);
                }
            });
        },

        async fetchSelfService() {
            let self = this

            await db.collection("ServiceBooking"+self.$stage).where("customerType", "==", "Self-Service")
            .onSnapshot(function(querySnapshot) {
                self.previousSelfService = []
                self.selfService = []
                self.todaySelfService = []
                var serviceYesterday = []
                var todayService = []
                var prevMonthFirstDay = new moment().utcOffset('+0800').subtract(1, 'months').date(1).toISOString().substr(0, 10)
                var startOfMonth = moment().utcOffset('+0800').startOf('month').add(1, 'days').toISOString().substr(0, 10)
                var endOfMonth = moment().utcOffset('+0800').endOf('month').toISOString().substr(0, 10)
                var prevStartOfMonth = moment(prevMonthFirstDay).utcOffset('+0800').startOf('month').add(1, 'days').toISOString().substr(0, 10)
                var prevEndOfMonth = moment(prevMonthFirstDay).utcOffset('+0800').endOf('month').toISOString().substr(0, 10)
                var today = new moment().utcOffset('+0800').toISOString().substr(0, 10)
                var yesterday = new moment().utcOffset('+0800').subtract(1, 'days').toISOString().substr(0, 10)
                querySnapshot.forEach(function(doc) {
                    if(doc.data().appointmentDate >= startOfMonth && doc.data().appointmentDate <= endOfMonth ) {
                        self.selfService.push(doc.data())
                        if (doc.data().appointmentDate == yesterday) {
                            serviceYesterday.push(doc.data())
                        } else if (doc.data().appointmentDate == today) {
                            todayService.push(doc.data())
                            self.todaySelfService.push(doc.data())
                        }
                    } else if (doc.data().appointmentDate >= prevStartOfMonth && doc.data().appointmentDate <= prevEndOfMonth) {
                        self.previousSelfService.push(doc.data())
                    }
                });
                self.selfServicePercentage = (((self.selfService.length / self.previousSelfService.length)*100)-100).toFixed(2)
                self.selfServiceComparison = (todayService.length - serviceYesterday.length)
            });
        },

        async fetchWalkIn() {
            let self = this;

            await db.collection("ServiceBooking"+self.$stage).where("customerType", "==", "Walk-in")
            .onSnapshot(function(querySnapshot) {
                self.previousWalkin = []
                self.walkin = []
                var serviceYesterday = []
                var todayService = []
                var prevMonthFirstDay = new moment().subtract(1, 'months').date(1).toISOString().substr(0, 10)
                var startOfMonth = moment().startOf('month').add(1, 'days').toISOString().substr(0, 10)
                var endOfMonth = moment().endOf('month').toISOString().substr(0, 10)
                var prevStartOfMonth = moment(prevMonthFirstDay).startOf('month').add(1, 'days').toISOString().substr(0, 10)
                var prevEndOfMonth = moment(prevMonthFirstDay).endOf('month').toISOString().substr(0, 10)
                var today = new moment().utcOffset('+0800').toISOString().substr(0, 10)
                var yesterday = new moment().utcOffset('+0800').subtract(1, 'days').toISOString().substr(0, 10)

                querySnapshot.forEach(function(doc) {
                    if(doc.data().appointmentDate >= startOfMonth && doc.data().appointmentDate <= endOfMonth ) {
                        self.walkin.push(doc.data())
                        if (doc.data().appointmentDate == yesterday) {
                            serviceYesterday.push(doc.data())
                        } else if (doc.data().appointmentDate == today) {
                            todayService.push(doc.data())
                            self.todayWalkin.push(doc.data())
                        }
                    } else if (doc.data().appointmentDate >= prevStartOfMonth && doc.data().appointmentDate <= prevEndOfMonth ) {
                        self.previousWalkin.push(doc.data())
                    }
                });
                self.walkinPercentage = (((self.walkin.length / self.previousWalkin.length)*100)-100).toFixed(2)
                self.walkinComparison = (todayService.length - serviceYesterday.length)
            });
        },

        async fetchCancelled() {
            let self = this

            await db.collection("ServiceBooking"+self.$stage).where("tag", "==", "No Show")
            .onSnapshot(function(querySnapshot) {
                self.previousCancelled = []
                self.cancelledTransactions = []
                var serviceYesterday = []
                var todayService = []
                var prevMonthFirstDay = new moment().utcOffset('+0800').subtract(1, 'months').date(1).toISOString().substr(0, 10)
                var startOfMonth = moment().utcOffset('+0800').startOf('month').add(1, 'days').toISOString().substr(0, 10)
                var endOfMonth = moment().utcOffset('+0800').endOf('month').toISOString().substr(0, 10)
                var prevStartOfMonth = moment(prevMonthFirstDay).utcOffset('+0800').startOf('month').add(1, 'days').toISOString().substr(0, 10)
                var prevEndOfMonth = moment(prevMonthFirstDay).utcOffset('+0800').endOf('month').toISOString().substr(0, 10)
                var today = new moment().utcOffset('+0800').toISOString().substr(0, 10)
                var yesterday = new moment().utcOffset('+0800').subtract(1, 'days').toISOString().substr(0, 10)
                
                querySnapshot.forEach(function(doc) {
                    if (doc.data().status == "Cancelled" || doc.data().status == "Rejected") {
                        if(doc.data().appointmentDate >= startOfMonth && doc.data().appointmentDate <= endOfMonth) {
                            self.cancelledTransactions.push(doc.data())
                            if (doc.data().appointmentDate == yesterday) {
                                serviceYesterday.push(doc.data())
                            } else if (doc.data().appointmentDate == today) {
                                todayService.push(doc.data())
                                self.todayCancelled.push(doc.data())
                            }
                        } else if (doc.data().appointmentDate >= prevStartOfMonth && doc.data().appointmentDate <= prevEndOfMonth ) {
                            self.previousCancelled.push(doc.data())
                        }
                    }  
                });
                self.cancelPercentage = (((self.cancelledTransactions.length / self.previousCancelled.length)*100)-100).toFixed(2)
                self.cancelComparison = (todayService.length - serviceYesterday.length)
            });
        },

        async fetchForApproval() {
            let self = this

            await db.collection("ServiceBooking"+self.$stage).where("status", "==", "ForApproval")
            .onSnapshot(function(querySnapshot) {
                self.previousForApproval = []
                self.forApprovalTransactions = []
                var serviceYesterday = []
                var todayService = []
                var prevMonthFirstDay = new moment().utcOffset('+0800').subtract(1, 'months').date(1).toISOString().substr(0, 10)
                var startOfMonth = moment().utcOffset('+0800').startOf('month').add(1, 'days').toISOString().substr(0, 10)
                var endOfMonth = moment().utcOffset('+0800').endOf('month').toISOString().substr(0, 10)
                var prevStartOfMonth = moment(prevMonthFirstDay).utcOffset('+0800').startOf('month').add(1, 'days').toISOString().substr(0, 10)
                var prevEndOfMonth = moment(prevMonthFirstDay).utcOffset('+0800').endOf('month').toISOString().substr(0, 10)
                var today = new moment().utcOffset('+0800').toISOString().substr(0, 10)
                var yesterday = new moment().utcOffset('+0800').subtract(1, 'days').toISOString().substr(0, 10)
                
                querySnapshot.forEach(function(doc) {
                    if(doc.data().appointmentDate >= startOfMonth && doc.data().appointmentDate <= endOfMonth) {
                        self.forApprovalTransactions.push(doc.data())
                        if (doc.data().appointmentDate == yesterday) {
                            serviceYesterday.push(doc.data())
                        } else if (doc.data().appointmentDate == today) {
                            todayService.push(doc.data())
                            self.todayForApproval.push(doc.data())
                        }
                    } else if (doc.data().appointmentDate >= prevStartOfMonth && doc.data().appointmentDate <= prevEndOfMonth ) {
                        self.previousForApproval.push(doc.data())
                    }
                });
                self.forApprovalPercentage = (((self.forApprovalTransactions.length / self.previousForApproval.length)*100)-100).toFixed(2)
                self.forApprovalComparison = (todayService.length - serviceYesterday.length)
            });
        },

        async fetchUsersLogin() {
            let self = this
            
            await db.collection("2FACodes").where("status", "==", 1)
            .onSnapshot(function(querySnapshot) {
                self.previousSession = []
                self.sessions = []
                var serviceYesterday = []
                var todayService = []
                var prevMonthFirstDay = new moment().subtract(1, 'months').date(1).toISOString().substr(0, 10)
                var startOfMonth = moment().startOf('month').add(1, 'days').toISOString().substr(0, 10)
                var endOfMonth = moment().endOf('month').toISOString().substr(0, 10)
                var prevStartOfMonth = moment(prevMonthFirstDay).startOf('month').add(1, 'days').toISOString().substr(0, 10)
                var prevEndOfMonth = moment(prevMonthFirstDay).endOf('month').toISOString().substr(0, 10)
                var today = new moment().utcOffset('+0800').toISOString().substr(0, 10)
                var yesterday = new moment().utcOffset('+0800').subtract(1, 'days').toISOString().substr(0, 10)
                
                querySnapshot.forEach(function(doc) {
                    if(doc.data().createdDate >= startOfMonth && doc.data().createdDate <= endOfMonth ) {
                        self.sessions.push(doc.data())
                        if (doc.data().createdDate == yesterday) {
                            serviceYesterday.push(doc.data())
                        } else if (doc.data().createdDate == today) {
                            todayService.push(doc.data())
                            self.todaySession.push(doc.data())
                        }
                    } else if (doc.data().createdDate >= prevStartOfMonth && doc.data().createdDate <= prevEndOfMonth ) {
                        self.previousSession.push(doc.data())
                    }
                });
                self.sessionPercentage = (((self.sessions.length / self.previousSession.length)*100)-100).toFixed(2)
                self.sessionComparison = (todayService.length - serviceYesterday.length)
            });
        },

        async fetchLaborSales() {
            let self = this

            await db.collection("ServiceBooking"+self.$stage).where('tag', '==', "Show")
            .onSnapshot(function(querySnapshot) {
                var cost = []
                var process = 0
                var fetch = 0
                var x = 0
                var y = 0
                var x1 = 0
                var y1 = 0
                self.laborSales = []
                self.previousSales = []
                var serviceYesterday = []
                var todayService = []
                self.allTotalSales=[]
                var salesYesterday = []
                var salesToday = []
                var totalSalesYesterday = 0
                var totalSalesToday = 0
                var salesLastMonth = []
                var salesMonth = []
                var totalSalesMonth = 0
                var prevMonthFirstDay = new moment().subtract(1, 'months').date(1).toISOString().substr(0, 10)
                var startOfMonth = moment().startOf('month').add(1, 'days').toISOString().substr(0, 10)
                var endOfMonth = moment().endOf('month').toISOString().substr(0, 10)
                var prevStartOfMonth = moment(prevMonthFirstDay).startOf('month').add(1, 'days').toISOString().substr(0, 10)
                var prevEndOfMonth = moment(prevMonthFirstDay).endOf('month').toISOString().substr(0, 10)
                var today = new moment().utcOffset('+0800').toISOString().substr(0, 10)
                var yesterday = new moment().utcOffset('+0800').subtract(1, 'days').toISOString().substr(0, 10)
                querySnapshot.forEach(function(doc) {
                    self.allTotalSales.push(doc.data())
                    if(doc.data().appointmentDate >= startOfMonth && doc.data().appointmentDate <= endOfMonth) {
                        self.laborSales.push(doc.data())
                        fetch ++
                        if (doc.data().appointmentDate == yesterday) {
                            serviceYesterday.push(doc.data())
                        } else if (doc.data().appointmentDate == today) {
                            todayService.push(doc.data())
                        }
                    }  else if (doc.data().appointmentDate >= prevStartOfMonth && doc.data().appointmentDate <= prevEndOfMonth ) {
                        self.previousSales.push(doc.data())
                    }
                })
                if (fetch === self.laborSales.length) {
                    self.laborSales.forEach(function(res) {
                        cost.push((res.estimateCharge.replace("PHP","").replace(",", "").trim()))
                        process ++
                    })
                    if( process === cost.length) {
                        if (cost.length > 0) {
                            cost = _.map(cost, _.ary(parseInt, 1))
                            self.totalLaborSales = cost.reduce((a, b) => a + b)
                            var nf = new Intl.NumberFormat('en-US', {
                                style: 'currency',
                                currency: 'Php',
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2
                            });
                            nf.format(self.totalLaborSales)
                            self.totalLaborSales = nf.format(self.totalLaborSales) 
                        }
                    }

                    serviceYesterday.forEach(function(res) {
                        salesYesterday.push(res.estimateCharge.replace("PHP","").replace(",", "").trim())
                        x++
                    })
                    todayService.forEach(function(res) {
                        salesToday.push(res.estimateCharge.replace("PHP","").replace(",", "").trim())
                        y++
                    })

                    if(serviceYesterday.length === x) {
                        if ( salesYesterday.length > 0) {
                            salesYesterday = _.map(salesYesterday, _.ary(parseInt, 1))
                            totalSalesYesterday = salesYesterday.reduce((a, b) => a + b)
                        } else {
                            totalSalesYesterday = 0
                        }
                    }
    
                    if(todayService.length === y) {
                        if ( salesToday.length > 0) {
                            salesToday = _.map(salesToday, _.ary(parseInt, 1))
                            totalSalesToday = salesToday.reduce((a, b) => a + b)
                            console.log(totalSalesToday)
                        } else {
                            totalSalesToday = 0
                        }  
                    }

                    self.laborSales.forEach(function(res) {
                        salesMonth.push(res.estimateCharge.replace("PHP","").replace(",", "").trim())
                        x1++
                    })

                    if(salesMonth.length === x1) {
                        if ( salesMonth.length > 0) {
                            salesMonth = _.map(salesMonth, _.ary(parseInt, 1))
                            totalSalesMonth = salesMonth.reduce((a, b) => a + b)
                        } else {
                            totalSalesMonth = 0
                        }
                    }

                    self.previousSales.forEach(function(res) {
                        salesLastMonth.push(res.estimateCharge.replace("PHP","").replace(",", "").trim())
                        y1++
                    })

                    if(salesLastMonth.length === y1) {
                        if ( salesLastMonth.length > 0) {
                            salesLastMonth = _.map(salesLastMonth, _.ary(parseInt, 1))
                            self.totalSalesLastMonth = salesLastMonth.reduce((a, b) => a + b)
                        } else {
                            self.totalSalesLastMonth = 0
                        }
                    }

                    self.salesComparison = (totalSalesToday - totalSalesYesterday)
                    self.salesPercentage = (((totalSalesMonth / self.totalSalesLastMonth)*100)-100).toFixed(2)
                    
                    self.allTotalSales.forEach(function(doc) {
                        var d=new Date(doc.appointmentDate)
                        var shortMonthName = new Intl.DateTimeFormat("en-US", { month: "short" }).format
                        var shortName = shortMonthName(d)
                        var m = d.getMonth()+1
                        var year = d.getFullYear()
                        doc.year = year
                        doc.monthGroup = m
                        doc.monthGroupName = shortName
                        doc.estimateCharge= doc.estimateCharge.replace("PHP","").replace(",", "").trim()
                    })

                    setTimeout(() => {
                        var result = _.chain(self.allTotalSales)
                        .filter('year')
                        .groupBy(x => x.monthGroupName)
                        .map((value, key) => 
                            ({  month: key,
                                totalamount:_.sumBy(_.map(value, 'estimateCharge'),_.ary(parseInt, 1)),
                                year: _.map(value, "year").map(_.spread(_.merge)),
                            })).value();
                            self.laborSalesValues = result
                        
                        self.laborSalesValues.forEach(function(doc) {
                            self.value.push(doc.totalamount)
                            self.labels.push(doc.month)
                            self.laborChartOptionsBar.xAxis.data.push(doc.month)
                            self.laborChartOptionsBar.series.forEach(function(res) {
                                res.data.push(doc.totalamount)
                            })
                        })
                    }, 1000);
                } 
            })      
        },

        async fetchTopBranches() {
            let self = this

            await db.collection("ServiceBooking"+self.$stage).where('tag', '==', "Show")
            .onSnapshot(function(querySnapshot) {
                var unit = []
                var process = 0
                var fetch = 0
                var sortBranches = {}
                var listBranch = []
                var prevMonthFirstDay = new moment().subtract(1, 'months').date(1).toISOString().substr(0, 10)
                var startOfMonth = moment().startOf('month').add(1, 'days').toISOString().substr(0, 10)
                var endOfMonth = moment().endOf('month').toISOString().substr(0, 10)
                var prevStartOfMonth = moment(prevMonthFirstDay).startOf('month').add(1, 'days').toISOString().substr(0, 10)
                var prevEndOfMonth = moment(prevMonthFirstDay).endOf('month').toISOString().substr(0, 10)
                var today = new moment().utcOffset('+0800').toISOString().substr(0, 10)
                var yesterday = new moment().utcOffset('+0800').subtract(1, 'days').toISOString().substr(0, 10)
                
                querySnapshot.forEach(function(doc) {
                    if(doc.data().appointmentDate >= prevStartOfMonth && doc.data().appointmentDate <= prevEndOfMonth) {
                        listBranch.push({
                            appointmentDate: doc.data().appointmentDate,
                            branch: doc.data().branch,
                            laborSales: doc.data().estimateCharge.replace("PHP"," ").replace(",","").trim(),
                        })
                        fetch ++
                    }
                })

                if (fetch === listBranch.length) {
                    listBranch.forEach(function(res) {
                        unit.push(res)
                        process ++
                    })
                    if(process === unit.length) {
                        listBranch = unit

                        sortBranches = _(listBranch).groupBy('branch')
                        .map((item, key) => ({
                            branch: key,
                            laborSales: _.sumBy(_.map(item, 'laborSales'),_.ary(parseInt, 1)),
                            laborCount: item.length,
                            percentage: ((_.sumBy(_.map(item, 'laborSales'),_.ary(parseInt, 1)) / Number(self.totalSalesLastMonth))*100).toFixed(2)
                        })).value()

                        self.topBranches = Object.fromEntries(Object.entries(sortBranches).sort().reverse())
                        self.topBranches = Object.values(self.topBranches)
                        self.topBranches = _.orderBy(self.topBranches, ['percentage'],['desc'])
                        
                        setTimeout(() => {
                            self.topBranches = self.topBranches.slice(0,5)
                            self.topBranches.forEach(function(res) {
                                self.branchesLabel.push(res.branch)
                                self.branchesValue.push(Number(res.percentage))
                                self.branchChartOptionsBar.yAxis.data.push(res.branch)
                                self.branchChartOptionsBar.series.forEach(function(doc) {
                                    doc.data.push(Number(res.percentage))
                                })
                            })
                        }, 1000);
                    }
                } 
            })
        },
    },

    mounted() {
        this.fetchTransactions()
        this.fetchSelfService()
        this.fetchWalkIn()
        this.fetchCancelled()
        this.fetchForApproval()
        this.fetchUsersLogin()
        this.fetchLaborSales()
        this.fetchTopBranches()
        this.fetchShowTransactions()
    },

    computed : {
        ...mapGetters(["user"]),
    },
}
</script>

<style scoped>
.v-sheet--offset {
  top: -24px;
  position: relative;
}
.chart-wrapper {
  width: 100%;
  height: 350px;
}
.echarts {
  width: 100%;
  height: 100%;
}
</style>




